/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsV1SweepPlanEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_V1_SWEEP_PLAN_EVENT_ENTITY_NAME = 'ixc.sweeps.v1.SweepPlanEvent';
export const ixcSweepsV1SweepPlanEventEntity = new schema.Entity<IxcSweepsV1SweepPlanEvent>(IXC_SWEEPS_V1_SWEEP_PLAN_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcSweepsV1SweepPlanEvent) => `${entity.metadata?.eventId}` });

